// 操作マニュアル
const MANUAL_URL = {
  uni: '/api/uni/setting/download/manual',
};

export default {
  MANUAL_URL,
};
